import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree,Router } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthenticationService} from '../dashboard-login/authentication.service';
@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private authenticationService: AuthenticationService, private _router:Router){}
  canActivate():boolean{
    if (this.authenticationService.loggedIn()){
      return true;
    }else{
      this._router.navigate(['/login'])
      return false;
    }
  }


}
